// <www.sharporator.com[readonly.file]> do not change the file or delete this line

import React from 'react'
/*
Example of calling the component from 'getAuthTokenPresenter.jsx':

...
import EndpointsTestingComponent from './endpointsTestingComponent'
...

    <EndpointsTestingComponent
        authToken={authToken}
        onAuthTokenPost={onAuthTokenPost}
        onAuthTokenClear={onAuthTokenClear}
        {...props}
    />

*/
    export default
        function EndpointsTestingComponent(
        {
            authToken, // fetch result of '/Proxy/GetAuthToken',
            // //------------------------------------------
            onAuthTokenPost, // fetch '/Proxy/GetAuthToken',
            // //------------------------------------------
            onAuthTokenClear,
            // //------------------------------------------
            ...props
        }
        )
        {
            const [merchantDeviceIdauthToken, setMerchantDeviceIdauthToken] = React.useState('')
            React.useEffect(() => {
                const str =
                    authToken === null || authToken === undefined
                    ? ""
                    : JSON.stringify(authToken, undefined, 2);

                document.getElementById("getAuthTokenJsonId").innerHTML = str;
            }, [authToken])
            function listReferenceRender() {
                return (
                    <div className='container-lg'>
                        <a
                            href='current#'
                            onClick={(event) => {
                                event.preventDefault();
                                props.history.push('/endpoint-testing-list');
                            }}
                        >
                            testing components list
                        </a>
                    </div>
                )
            }
            function proxyGetAuthTokenAuthTokenTestingForm() {
                return (
                    <>
                        <hr/>
                        <hr/>
                        <fieldset className='container-lg'>
                            <legend>Input values for endpoint '<span style={{color: 'blue'}}>/api/Proxy/GetAuthToken'</span></legend>
                            <p><span><b>Авторизация для получения Token</b></span></p>
                            <p><span><b>Server call</b></span></p>
                            <form className='form-group' onReset={()=>onAuthTokenClear()} onSubmit={event => {
                                event.preventDefault()
                                if (!merchantDeviceIdauthToken) {
                                    alert("'MerchantDeviceId' is required.")
                                    return
                                }
                                onAuthTokenPost({merchantDeviceId: merchantDeviceIdauthToken})
                            }}>
                            <div style={{marginTop: 8}} className='card'>
                                <div className='card-body'>
                                    <p style={{marginTop: 10}}><b>Body object properties (InputView properties):</b></p>
                                        <div style={{marginTop: 16}}>
                                            <div  style={{marginTop: 0}}>
                                                <label htmlFor='merchantDeviceIdauthTokenId' className='form-label'>MerchantDeviceId</label>
                                                <input type='text' id='merchantDeviceIdauthTokenId' className='form-control' value={merchantDeviceIdauthToken} onChange={event => setMerchantDeviceIdauthToken(event.target.value)}/>
                                                {!merchantDeviceIdauthToken && (
                                                    <div style={{ color: '#D83A3A' }}>
                                                        The 'MerchantDeviceId' is required.
                                                    </div>
                                                )}
                                            </div>

                                        </div>
                                    <input className='btn btn-primary' style={{marginTop: 24}} type = 'submit' value = 'Submit'/>
                                    <input className='btn' style={{marginTop: 24, marginLeft: 16}} type = 'reset' value = 'Clear'/>
                                </div>
                            </div>
                            </form>
                        </fieldset>
                        {proxyGetAuthTokenAuthTokenTestingResult()}
                    </>
                )
            }
            function proxyGetAuthTokenAuthTokenTestingResult() {
                return (
                    <>
                        <div style={{marginTop: 32}} className='container-lg'>
                            <p><b>Result of endpoint '<span style={{color: 'navy'}}>/api/Proxy/GetAuthToken</span>':</b></p>
                            <span>{'--> string authToken'}</span>
                            <pre id="getAuthTokenJsonId"></pre>
                        </div>
                    </>
                )
            }
            return (
                <>
                    {listReferenceRender()}
                    {proxyGetAuthTokenAuthTokenTestingForm()}
                </>
            )
        }
